import React, {useEffect, useRef, useState} from 'react';
import {InputText} from "primereact/inputtext";
import {Password} from "primereact/password";
import {Button} from "primereact/button";
import {useFormik} from "formik";
import { classNames } from 'primereact/utils';
import {useTranslate} from "../system/useTranslate";
import {useDispatch, useSelector} from "react-redux";
import {generateCaptcha, login, saveUser, setOtpSent, signup} from "./auth-slice";
import {fetchAppData, setMessage} from "../system/app-slice";
import {farsiDigitsToInt} from "../system/utils";
import packageJson from '../../package.json';
import {sha1} from "js-sha1";
import {Divider} from "primereact/divider";
import {Dropdown} from "primereact/dropdown";
import {getSiteConfigs, setSiteConfigs, setUser} from "../system/storage";
import LanguageItem from "../system/components/language-item";
import {InputOtp} from "primereact/inputotp";
import Countdown from "../system/components/count-down";
import {Checkbox} from "primereact/checkbox";
import {DotLottieReact} from "@lottiefiles/dotlottie-react";
import InputCountrycodePhonenumber from "../system/components/input-countrycode-phonenumber";
import LoadingLottie from "../system/components/loading-lottie";
import api, {normalizeApiError} from "../system/api";
import SegmentedMenu from "../system/components/segmented-menu";
import {IconField} from "primereact/iconfield";
import BrandLogo from "../system/components/brand-logo";
import AuthBrandPattern from "../system/components/auth-brand-pattern";
import LegalContentDialog from "./legal-content-dialog";
import LoginTextRotator from "./login-text-rotator";
import {loginFormForCheckUser} from "./account-setup";

const SPLASH_DURATION = 900;

function Index(props) {
    const [showSplash, setShowSplash] = useState(true);

    useEffect(() => {
        const timer = window.setTimeout(() => setShowSplash(false), SPLASH_DURATION);

        return () => window.clearTimeout(timer);
    }, []);

    return (
        <div className="relative min-h-screen w-full flex align-items-center justify-content-center surface-ground overflow-hidden">
            <AuthBrandPattern/>
            <div className="relative z-1 w-full min-h-screen flex align-items-center justify-content-center">
                {/*<UserpassLogin/>*/}
                <PhoneNumberOtp/>
            </div>
            {showSplash && (
                <div className="fixed top-0 left-0 w-full h-full z-5 surface-ground flex align-items-center justify-content-center" role="status" aria-label="Loading workspace platform">
                    <LoadingLottie/>
                </div>
            )}
        </div>
    );
}

function UserpassLogin() {
    const dispatch = useDispatch();
    const { isAuthenticated, user, loading, error } = useSelector(state => state.auth);
    const submitLockRef = useRef(false);
    const {config, isDesktop} = useSelector((state) => state.app);
    const translate = useTranslate();
    const [captchaImage, setCaptchaImage]=useState();
    const [model, setModel] = useState([]);
    const [currentTab, setCurrentTab]=useState(model[0]);
    const [formType, setFormType]=useState();
    const [otpExpired, setOtpExpired]=useState();
    const [otpExpireTime, setOtpExpireTime]=useState();
    const [termOfService, setTermOfService]=useState();
    const [privacyPolicy, setPrivacyPolicy]=useState();

    useEffect(()=>{
        document.title = `${translate(config['app-name'])}`;
        setModel(prvData=>{
            let newData = [];
            if (config.auth['with-mobile']) newData = [...newData, {id:"mobile",label:translate("mobile"), icon: "pi pi-mobile"}]
            if (config.auth['with-email']) newData = [...newData, {id:"email",label:translate("email"), icon: "pi pi-envelope"}]
            setCurrentTab(newData[0]);
            return newData;
        });

        // displayCaptcha()
    },[])

    const displayCaptcha = async ()=>{
        if (config['captcha']&&config['captcha'].type==="crm-default"){
            try {
                let base64 = await generateCaptcha();
                setCaptchaImage(base64);
            }catch (e) {
                dispatch(setMessage({severity:"error", content:translate("captcha-error")}));
            }

        }

    }

    useEffect(()=>{
        if (error) dispatch(setMessage({severity:"error", content:translate(error)}));
    },[error])

    const formik = useFormik({
        initialValues: {
            Username: '',
            PhoneObject: { kphbase_abbreviation: "IR", kphbase_countrycode: "+98", phone: "" },
            Password: '',
            // Captcha: '',
        },
        validate: (data) => {
            // console.log(data)
            let errors = {};
            if (currentTab.id==="mobile"){
                if (!data.PhoneObject.phone) {
                    errors.Username = translate("username-invalid");
                }
            }else {
                if (!data.Username) {
                    errors.Username = translate("username-invalid");
                }
            }

            if (!data.Password) {
                errors.Password = translate("password-invalid");
            }
            // if (!data.Captcha) {
            //     errors.Captcha = translate("captcha-invalid");
            // }
            return errors;
        },
        onSubmit: async(data) => {
            if (loading || submitLockRef.current) return;
            submitLockRef.current = true;
            try {
                if (currentTab.id==="mobile") await dispatch(login({identifier:data.PhoneObject.kphbase_countrycode+data.PhoneObject.phone, password:data.Password}));
                else await dispatch(login({identifier:data.Username, password:data.Password}));
                displayCaptcha();
                formik.resetForm();
            } finally {
                submitLockRef.current = false;
            }

        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error text-xs">{formik.errors[name]}</small>;
    };

    const signupFormik = useFormik({
        initialValues: {
            Username: "",
            PhoneObject: { kphbase_abbreviation: "IR", kphbase_countrycode: "+98", phone: "" },
            Fullname: "",
            Password: "",
            ConfirmPassword: "",
            Captcha: "",
        },
        validate: (data) => {
            let errors = {};
            if (!data.Username) errors.Username = translate("username-invalid");
            if (!data.Fullname) errors.Fullname = translate("fullname-invalid");
            if (!data.Password) errors.Password = translate("password-invalid");
            if (data.Password !== data.ConfirmPassword)
                errors.ConfirmPassword = translate("passwords-not-match");
            if (!data.Captcha) errors.Captcha = translate("captcha-invalid");
            return errors;
        },
        onSubmit: async (data) => {
            if (loading || submitLockRef.current) return;
            submitLockRef.current = true;
            try {
                await dispatch(signup({ ...data, Password: sha1(data.Password) }));
                displayCaptcha();
                signupFormik.resetForm();
            } finally {
                submitLockRef.current = false;
            }
        },
    });

    const render=(type)=>{
        switch (type) {
            case "FORGET_PASSWORD":return (
                <div className="flex flex-wrap gap-3">
                    <div className="text-center w-full flex flex-column gap-2">
                        <span className="font-bold text-3xl text-primary">{translate('forget-password')}</span>
                        <span className="text-xs text-400">{translate("forget-password-description")}</span>

                    </div>
                    {model.length>1&&<SegmentedMenu model={model} value={currentTab} onChange={(e)=>{setCurrentTab(e.value)}}/>}
                    {
                        currentTab&&currentTab.id==='email'&&(
                            <span className="w-full ">
                                    <InputText id="username" name="Username" value={formik.values.Username} onChange={formik.handleChange} autoFocus className={classNames({'p-invalid': isFormFieldValid('Username'), 'w-full border-round-xl': true})} placeholder={translate("email-input-placeholder")}/>{getFormErrorMessage('Username')}
                                </span>
                        )
                    }
                    {
                        currentTab&&currentTab.id==='mobile'&&(
                            <span className="w-full">
                                <InputCountrycodePhonenumber/>
                                    {/*<InputText id="username" name="Username" value={formik.values.Username} onChange={formik.handleChange} autoFocus className={classNames({'p-invalid': isFormFieldValid('Username'), 'w-full border-round-xl': true})} placeholder={translate("mobile-input-placeholder")}/>{getFormErrorMessage('Username')}*/}
                                </span>
                        )
                    }
                    <Button onClick={()=>{setFormType("RESET_PASSWORD")}} className="w-full text-white border-round-xl" label={translate("send-reset-code")}/>
                    <Button onClick={()=>{setFormType(undefined)}} className="w-full p-button-secondary border-round-xl flex gap-2 align-items-center justify-content-center">
                        <span className="pi pi-arrow-left text-xs" />
                        <span>{translate("go-back")}</span>
                    </Button>
                </div>
            )
            case "OTP":return (
                <div className="flex flex-column gap-4 align-items-center justify-content-center">
                    {currentTab&&(
                        <div className="text-center w-full flex flex-column gap-2">
                            <span className="font-bold text-3xl text-primary">{translate(currentTab.id==="email"?'verify-email':"verify-phone")}</span>
                            <span className="text-xs text-400">{translate(currentTab.id==="email"?'verify-email-description':"verify-phone-description")} <span className="text-primary font-bold">{formik.values.Username}</span></span>
                        </div>
                    )}
                    <InputOtp style={{direction:"ltr"}} className="w-full" length={6} inputTemplate={({events, props}) => <input {...events} {...props} type="text" className="p-inputtext w-3rem border-round-xl text-center h-3rem font-bold" />} />

                    <div className="flex flex-column gap-2 align-items-center text-400 text-sm">
                        <div className="flex gap-1 align-items-center ltr">
                            <span className="pi pi-clock"/>
                            {otpExpired?(<span>{translate("otp-expired")}</span>):(<Countdown onComplete={()=>{setOtpExpired(true)}} targetDate={otpExpireTime} format="datetime"/>)}
                        </div>
                        {otpExpired&&<Button label={translate("resend-code")} onClick={()=>{setOtpExpired(false);setOtpExpireTime(new Date().getTime() + 80000)}} className="text-sm p-button-text"/>}
                    </div>
                    <Button disabled={otpExpired} className="w-full text-white border-round-xl" label={translate("verify-code")}/>
                    <Button onClick={()=>{setFormType(undefined)}} className="w-full p-button-secondary border-round-xl flex gap-2 align-items-center justify-content-center">
                        <span className="pi pi-arrow-left text-xs" />
                        <span>{translate("go-back")}</span>
                    </Button>
                </div>
            )
            case "RESET_PASSWORD":return (
                <div className="flex flex-column gap-4 align-items-center justify-content-center">
                    {currentTab&&(
                        <div className="text-center w-full flex flex-column gap-2">
                            <span className="font-bold text-3xl text-primary">{translate("reset-password")}</span>
                            <span className="text-xs text-400">{translate("reset-password-description")}</span>
                        </div>
                    )}
                    <InputOtp style={{direction:"ltr"}} className="w-full" length={6} inputTemplate={({events, props}) => <input {...events} {...props} type="text" className="p-inputtext w-3rem border-round-xl text-center h-3rem font-bold" />} />
                    <div className="flex flex-column gap-3 w-full">
                        <Password feedback={false} id="password" name="Password" value={formik.values.Password} onChange={formik.handleChange} inputClassName="w-full border-round-xl" className={classNames({'p-invalid': isFormFieldValid('Password'), 'w-full': true})} inputStyle={{direction:"ltr"}} placeholder={translate("password-input-placeholder")}/>
                        <Password feedback={false} id="password" name="Password" value={formik.values.Password} onChange={formik.handleChange} inputClassName="w-full border-round-xl" className={classNames({'p-invalid': isFormFieldValid('Password'), 'w-full': true})} inputStyle={{direction:"ltr"}} placeholder={translate("password-input-placeholder")}/>
                    </div>
                    <Button onClick={()=>{setFormType(undefined)}} className="w-full text-white border-round-xl" label={translate("reset-password")}/>
                    <Button onClick={()=>{setFormType("FORGET_PASSWORD")}} className="w-full p-button-secondary border-round-xl flex gap-2 align-items-center justify-content-center">
                        <span className="pi pi-arrow-left text-xs" />
                        <span>{translate("go-back")}</span>
                    </Button>
                </div>
            )
            case "SIGN_UP":return (
                <form className="w-full" onSubmit={signupFormik.handleSubmit}>
                    <div className="flex flex-wrap gap-3">
                        <div className="text-center w-full flex flex-column gap-2">
                            <span className="font-bold text-3xl text-primary">{translate("create-account")}</span>
                            <span className="text-xs text-400">{translate("create-account-description")}</span>
                        </div>

                        {model.length > 1 && (<SegmentedMenu model={model} value={currentTab} onChange={(e) => setCurrentTab(e.value)}/>)}

                        {/* Username field */}
                        <span className="w-full">
                            <InputText id="username" name="Username" value={signupFormik.values.Username} onChange={signupFormik.handleChange} className={classNames({"p-invalid": signupFormik.touched.Username && signupFormik.errors.Username, "w-full border-round-xl": true,})} placeholder={currentTab?.id === "email" ? translate("email-input-placeholder") : translate("mobile-input-placeholder")}/>
                            {signupFormik.touched.Username && (
                                <small className="p-error text-xs">{signupFormik.errors.Username}</small>
                            )}
                        </span>

                        {/* Fullname */}
                        <span className="w-full">
                            <InputText id="fullname" name="Fullname" value={signupFormik.values.Fullname} onChange={signupFormik.handleChange} className="w-full border-round-xl" placeholder={translate("fullname-input-placeholder")}/>
                            {signupFormik.touched.Fullname && (
                                <small className="p-error text-xs">{signupFormik.errors.Fullname}</small>
                            )}
                        </span>

                        {/* Password */}
                        <span className="w-full">
                            <Password feedback={false} id="password" name="Password" value={signupFormik.values.Password} onChange={signupFormik.handleChange} inputClassName="w-full border-round-xl" className={classNames({"p-invalid": signupFormik.touched.Password && signupFormik.errors.Password, "w-full": true,})} placeholder={translate("password-input-placeholder")}/>
                            {signupFormik.touched.Password && (
                                <small className="p-error text-xs">{signupFormik.errors.Password}</small>
                            )}
                        </span>

                        {/* Confirm Password */}
                        <span className="w-full">
                            <Password feedback={false} id="confirmPassword" name="ConfirmPassword" value={signupFormik.values.ConfirmPassword} onChange={signupFormik.handleChange} inputClassName="w-full border-round-xl" className={classNames({"p-invalid": signupFormik.touched.ConfirmPassword && signupFormik.errors.ConfirmPassword, "w-full": true,})} placeholder={translate("confirm-password-placeholder")}/>
                            {signupFormik.touched.ConfirmPassword && (
                                <small className="p-error text-xs">{signupFormik.errors.ConfirmPassword}</small>
                            )}
                        </span>

                        <div className="flex flex-column gap-2">
                            <div className="flex align-items-center gap-1">
                                <Checkbox checked={termOfService} onChange={(e)=>{setTermOfService(e.checked)}}/>
                                <span>{translate("term-of-service")}</span>
                            </div>
                            <div className="flex align-items-center gap-1">
                                <Checkbox checked={privacyPolicy} onChange={(e)=>{setPrivacyPolicy(e.checked)}}/>
                                <span>{translate("privacy-policy")}</span>
                            </div>
                        </div>

                        {/* Captcha */}
                        {captchaImage && (
                            <div className="w-full">
                                <div className="p-inputgroup ltr w-full ">
                                    <Button type="button" icon="pi pi-refresh" className="p-button-outlined border-round-left-xl w-2rem" onClick={() => displayCaptcha()}/>
                                    <span className="p-inputgroup-addon p-0 w-4">
                                        <img width="100%" height="100%" src={`data:image/png;base64,${captchaImage}`}/>
                                    </span>
                                    <span className="p-inputgroup-addon p-0 flex-1 border-round-right-xl">
                                        <InputText id="captcha" name="Captcha" placeholder={translate("captcha-placeholder")} value={signupFormik.values.Captcha} onChange={signupFormik.handleChange} className={classNames({"p-invalid": signupFormik.touched.Captcha && signupFormik.errors.Captcha, "text-center bg-transparent p-1 shadow-none border-none w-full": true,})}/></span>
                                </div>
                                {signupFormik.touched.Captcha && (
                                    <small className="p-error text-xs">{signupFormik.errors.Captcha}</small>
                                )}
                            </div>
                        )}

                        {/* Submit */}
                        <Button type="submit" disabled={!(termOfService && privacyPolicy)} loading={loading} className="w-full border-round-xl text-white text-sm" label={translate("create-account")}/>

                        {/* Switch back to login */}
                        <div className="w-full justify-content-center align-items-center gap-1 flex mt-3">
                            <span>{translate("already-have-account")}</span>
                            <Button type="button" onClick={() => setFormType(undefined)} className="text-sm p-button-text shadow-none p-1" label={translate("sign-in")}/>
                        </div>
                        {error && <span className="text-red-500">{translate(error)}</span>}
                    </div>
                </form>

            )
            default:return(
                <form className="w-full" onSubmit={formik.handleSubmit} >
                    <div className="flex flex-wrap gap-3">

                        <div className="text-center w-full flex flex-column gap-2">
                            {/*<span className="font-bold text-3xl text-primary">{translate(config['app-name'])}</span>*/}
                            <span className="text-xs text-400">{translate("login-description")}</span>

                        </div>

                        {model.length>1&&<SegmentedMenu model={model} value={currentTab} onChange={(e)=>{setCurrentTab(e.value)}}/>}
                        {
                            currentTab&&currentTab.id==='email'&&(
                                <span className="w-full ">
                                    <InputText id="username" name="Username" value={formik.values.Username} onChange={formik.handleChange} autoFocus className={classNames({'p-invalid': isFormFieldValid('Username'), 'w-full border-round-xl': true})} placeholder={translate("email-input-placeholder")}/>{getFormErrorMessage('Username')}
                                </span>
                            )
                        }
                        {
                            currentTab&&currentTab.id==='mobile'&&(
                                <span className="w-full">
                                    <InputCountrycodePhonenumber name="PhoneObject" allowedCountries={["IR"]} value={formik.values.PhoneObject} onChange={(e) => {formik.setFieldValue("PhoneObject", e)}}/>
                                    {/*<InputText id="username" name="Username" value={formik.values.Username} onChange={formik.handleChange} autoFocus className={classNames({'p-invalid': isFormFieldValid('Username'), 'w-full border-round-xl': true})} placeholder={translate("mobile-input-placeholder")}/>{getFormErrorMessage('Username')}*/}
                                </span>
                            )
                        }

                        <span className="w-full">
                            <Password feedback={false} id="password" name="Password" value={formik.values.Password} onChange={formik.handleChange} inputClassName="w-full border-round-xl" className={classNames({'p-invalid': isFormFieldValid('Password'), 'w-full ': true})} placeholder={translate("password-input-placeholder")}/>
                            {getFormErrorMessage('Password')}
                        </span>
                        {config.auth['forget-password']&&<div className="w-full justify-content-end flex"><Button type="button" className="text-sm p-button-text shadow-none p-1" onClick={()=>{setFormType("FORGET_PASSWORD")}} label={translate("forget-password-question")}/></div>}
                        {
                            captchaImage && (
                                <div className="w-full">
                                    <div className="p-inputgroup ltr w-full ">
                                        <Button type="button" icon="pi pi-refresh" className="p-button-outlined border-round-left-xl w-2rem" onClick={() => {displayCaptcha()}}/>
                                        <span className="p-inputgroup-addon p-0 w-4"><img width="100%" height="100%" src={`data:image/png;base64,${captchaImage}`}/></span>
                                        <span className="p-inputgroup-addon p-0 flex-1 border-round-right-xl">
                                            <InputText id="captcha" name="Captcha" placeholder={translate("captcha-placeholder")} value={formik.values.Captcha} onChange={formik.handleChange} className={classNames({'p-invalid': isFormFieldValid('Captcha'), 'text-center bg-transparent p-1 shadow-none border-none w-full': true})}/>
                                        </span>
                                    </div>
                                    {getFormErrorMessage('Captcha')}
                                </div>
                            )
                        }
                        {config.auth.otp&&<Button type="button" onClick={()=>{setFormType("OTP"); setOtpExpireTime(new Date().getTime() + 80000)}} disabled={loading} className="w-full border-round-xl text-sm" label={translate("otp")}/>}
                        <Button type="submit" disabled={loading} loading={loading} className="w-full border-round-xl text-sm" label={translate("login-with-password")}/>

                        <div className="flex flex-column align-items-center w-full">
                            {(config.auth['with-google'] || config.auth['with-github'])&&<Divider className="text-400 mt-1">{translate("or-continue-with")}</Divider>}
                            <div className="flex align-items-center gap-2 w-full">
                                {config.auth['with-google']&&<Button type="button" className="p-button-outlined p-button-danger border-round-xl w-full" icon="pi pi-google" label="Google"/>}
                                {config.auth['with-github']&&<Button type="button" className="p-button-secondary p-button-outlined border-round-xl w-full" icon="pi pi-github" label="Github"/>}
                            </div>
                            {config.auth['sign-up']&&<div className="w-full justify-content-center align-items-center gap-1 flex mt-3">
                                <span>{translate("dont-have-account")}</span>
                                <Button onClick={()=>{setFormType("SIGN_UP")}} type="button" className="text-sm p-button-text shadow-none p-1" label={translate("sign-up")}/>
                            </div>}
                        </div>

                        {error && <span className="text-red-500">{translate(error)}</span>}
                    </div>
                </form>
            )
        }
    }

    return(
        <div className={`flex ${!isDesktop&&"flex-wrap flex-wrap-reverse overflow-auto scrollbar-hide"} lg:flex-row w-full h-full`}>
            <div className="w-full lg:w-4 lg:pt-8 overflow-auto scrollbar-hide p-4 flex flex-column align-items-center justify-content-center ">

                <div className="w-full p-4 lg:surface-card lg:border-round-3xl lg:shadow-2">
                    {render(formType)}
                </div>
                <div className="flex flex-column align-items-center justify-content-center p-2">
                    {
                        config.copyright.visible&&(
                            <div className="text-gray-400 text-xs text-center">
                                <span >Powered by </span>
                                <a className="text-gray-400" target="_blank" href={config.copyright.link}>{config.copyright.name}</a>
                            </div>)
                    }
                    <span className="text-gray-500 english-font text-xs">v {packageJson.version}</span>

                </div>
            </div>

            <div className="flex flex-column flex-1 surface-ground">
                <div className="flex p-3 justify-content-end">
                    {config["multi-language"]&&<Dropdown className="border-round-xl" panelClassName={`${config.dir}`} options={config['support-languages']} value={config['support-languages'][config['support-languages'].findIndex(l=>l.code===(getSiteConfigs()&&getSiteConfigs().language?getSiteConfigs().language.code:config.language))]} valueTemplate={(option, props)=>(<LanguageItem option={option} props={props} />)} itemTemplate={(option, props)=>(<LanguageItem option={option} props={props} />)} onChange={(e)=>{setSiteConfigs({...getSiteConfigs(), language:e.value}); dispatch(fetchAppData())}}/>}
                </div>
                <div className="flex-1 flex flex-column gap-3 justify-content-center align-items-center ">
                    <div className="w-full flex p-2 justify-content-center align-items-center">
                        <BrandLogo className="w-24rem max-w-full h-auto"/>
                    </div>
                    <span style={{marginTop:'-50px', whiteSpace:"pre-line"}} className="text-6xl font-bold text-center text-700 z-5">{translate(config["app-name"])}</span>
                    <span className="text-xl text-400 text-center">{translate("workspace-platform-description")}</span>
                </div>


            </div>

        </div>




        // <div className="w-full overflow-auto h-full relative flex flex-column pt-8 align-items-center justify-content-center scrollbar-hide">
        //     <div className="absolute top-0 right-0 p-3">
        //     </div>
        //
        // </div>
    )
}

function PhoneNumberOtp() {
    const dispatch = useDispatch();
    const {config} = useSelector((state) => state.app);
    const {otpSent, error} = useSelector(state => state.auth);
    const [loading, setLoading] = useState(false);
    const isRtl = config?.dir !== "ltr";

    const translate = useTranslate();
    const [formType, setFormType]=useState();
    const [otpExpired, setOtpExpired]=useState();
    const [otpExpireTime, setOtpExpireTime]=useState();
    const [mobile, setMobile]=useState();
    const [captcha, setCaptcha]=useState("");
    const [otp, setOtp]=useState();
    const [password, setPassword]=useState();
    const [legalDialog, setLegalDialog] = useState(null);
    const requestLockRef = useRef(false);

    const openLegalDialog = (name) => setLegalDialog(name);
    const legalKeyHandler = (event, name) => {
        if (["Enter", " "].includes(event.key)) {
            event.preventDefault();
            openLegalDialog(name);
        }
    };


    useEffect(()=>{
        document.title = `${translate(config['app-name'])}`;
        displayCaptcha()
    },[])

    const displayCaptcha = async ()=>{
        setCaptcha("");
        if (config['captcha']&&config['captcha'].type==="crm-default"){
            try {
                await generateCaptcha();
            }catch (e) {
                dispatch(setMessage({severity:"error", content:translate("captcha-error")}));
            }

        }
    }

    function validateParams({ mobile="", captcha=undefined }) {
        const errors = {};
        mobile = mobile?farsiDigitsToInt(mobile):undefined;
        // mobile: 11 digits starting with 0
        if (typeof mobile !== 'string' || !/^0\d{10}$/.test(mobile)) {
            errors.mobile = translate("mobile-invalid");
        }

        // if (captcha!==undefined){
        //     // captcha: not empty
        //     if (typeof captcha !== 'string' || captcha.trim() === '') {
        //         errors.captcha = translate("captcha-invalid");
        //     }
        // }

        if (Object.keys(errors).length > 0) {
            return { success: false, errors };
        }

        // حذف صفر اول شماره
        const data = {
            phone: mobile,
            // Channel:1,
            // Captcha: captcha
        };

        return { success: true, data };
    }

    useEffect(() => {

        if (otpSent){
            setFormType("OTP");
            setOtp(undefined)
            // setOtpExpireTime(new Date().getTime() + 80000);
            setOtpExpireTime(new Date(otpSent?.expireDate??null).getTime());
            setOtpExpired(false);
        }
        displayCaptcha();
    }, [otpSent]);

    useEffect(() => {
        if (error){
            dispatch(setMessage({severity:"error", content:error}))
        }
    }, [error]);


    const sendOtp = async (identifier)=>{
        if (requestLockRef.current) return;
        requestLockRef.current = true;
        setLoading(true);
        const headerConfig = {
            headers: { "Content-Type": "application/json" },
            withCredentials: true
        };
        try {
            await api.post('/otp/send', {...identifier}, headerConfig);
            dispatch(setOtpSent({expireDate:new Date().getTime() + 80000}))
            setFormType("OTP")
            // return { user, jwt, message: "login-successfully" };

        } catch (err) {
            dispatch(setMessage({severity:"error", content:normalizeApiError(err).message}));
        } finally {
            requestLockRef.current = false;
            setLoading(false);
        }
    }
    const checkUser = async (identifier)=>{
        if (requestLockRef.current) return;
        requestLockRef.current = true;
        setLoading(true);
        const headerConfig = {
            headers: { "Content-Type": "application/json" },
            withCredentials: true
        };
        try {
            const {data} = await api.post('/user/checkUser', {...identifier}, headerConfig);
            const nextForm = loginFormForCheckUser(data);
            if(nextForm === "OTP"){
                setFormType(nextForm);
                dispatch(setOtpSent({expireDate:new Date().getTime() + 80000}))
            }
            else {
                setFormType(nextForm);
            }
            // return { user, jwt, message: "login-successfully" };

        } catch (err) {
            dispatch(setMessage({severity:"error", content:normalizeApiError(err).message}));
        } finally {
            requestLockRef.current = false;
            setLoading(false);
        }
    }

    const confirmOtp = async (identifier, otp)=>{
        if (requestLockRef.current) return;
        requestLockRef.current = true;
        setLoading(true);
        const headerConfig = {
            headers: { "Content-Type": "application/json" },
            withCredentials: true
        };
        try {
            const { data:{user, jwt, refreshToken, deviceId, session, accountSetup} } = await api.post('/otp/verify', {...identifier, otp}, headerConfig);
            dispatch(saveUser({...user, jwt, refreshToken, deviceId, session, accountSetup}));
            dispatch(setOtpSent(undefined))
            return { user, jwt, message: "login-successfully" };

        } catch (err) {
            dispatch(setMessage({severity:"error", content:normalizeApiError(err).message}));
        } finally {
            requestLockRef.current = false;
            setLoading(false);
        }
    }

    const confirmPassword = async (identifier, password)=>{
        if (requestLockRef.current) return;
        requestLockRef.current = true;
        setLoading(true);
        const headerConfig = {
            headers: { "Content-Type": "application/json" },
            withCredentials: true
        };
        try {
            const { data:{user, jwt, refreshToken, deviceId, session} } = await api.post('/user/verifyPassword', {...identifier, password}, headerConfig);
            dispatch(saveUser({...user, jwt, refreshToken, deviceId, session}));
            dispatch(setOtpSent(undefined))
            return { user, jwt, message: "login-successfully" };

        } catch (err) {
            dispatch(setMessage({severity:"error", content:normalizeApiError(err).message}));
        } finally {
            requestLockRef.current = false;
            setLoading(false);
        }
    }

    const runWithValidMobile = (action) => {
        if (loading || requestLockRef.current) return;
        const validate = validateParams({mobile, captcha});
        if (validate.success) {
            action(validate.data);
            return;
        }
        Object.values(validate.errors).forEach(message => {
            dispatch(setMessage({severity:"error", content:message}));
        });
    };


    const render=(type)=>{
        switch (type) {
            case "OTP":return (
                <form className="w-full lg:w-6 h-auto p-4 sm:p-5 lg:p-6 flex flex-column gap-4 align-items-center justify-content-center fadeinup animation-duration-500" onSubmit={(event) => {
                    event.preventDefault();
                    if (otpExpired) runWithValidMobile(sendOtp);
                    else if (otp?.length === 4) runWithValidMobile((identifier) => confirmOtp(identifier, otp));
                }}>
                    <div className="text-center w-full flex flex-column gap-2">
                        <span className="font-bold text-3xl text-primary">{translate("verify-phone")}</span>
                        <span className="text-xs text-400">{translate("verify-phone-description")} <span className="text-primary font-bold">{mobile}</span></span>
                    </div>
                    <InputOtp disabled={loading} value={otp} inputMode="numeric" autoFocus onChange={(e)=>{setOtp(e.value); if(e.value.length===4){
                        let validate = validateParams({mobile});
                        if (validate.success){
                            confirmOtp(validate.data, e.value)
                        }
                        else {
                            Object.values(validate.errors).forEach(err=>{
                                dispatch(setMessage({severity:"error", content:err}))
                            })
                        }
                    }}} pt={{root: {dir: "ltr", className: "w-full justify-content-center"}}} length={4} inputTemplate={({events, props}) => <input {...events} {...props} type="text" className="p-inputtext w-3rem border-round-xl text-center h-3rem font-bold" />} />

                    <div className="flex flex-column gap-2 align-items-center text-400 text-sm">
                        <div className="flex gap-1 align-items-center ltr">
                            <span className="pi pi-clock"/>
                            {otpExpired?(<span>{translate("otp-expired")}</span>):(<Countdown onComplete={()=>{setOtpExpired(true)}} targetDate={otpExpireTime} format="datetime"/>)}
                        </div>
                        {otpExpired&&(
                            <>
                                {/*<div className="p-inputgroup ltr w-full ">*/}
                                {/*    <Button type="button" icon="pi pi-refresh" className="p-button-outlined w-2rem" onClick={() => displayCaptcha()}/>*/}
                                {/*    <span className="p-inputgroup-addon p-0 w-4">*/}
                                {/*        <img width="100%" height="100%" src={`data:image/png;base64,${captchaImage}`}/>*/}
                                {/*    </span>*/}
                                {/*    <span className="p-inputgroup-addon p-0 flex-1">*/}
                                {/*        <InputText id="captcha" name="Captcha" placeholder={translate("captcha-placeholder")} value={captcha} onChange={(e)=>{setCaptcha(e.target.value)}} className="text-center bg-transparent p-1 shadow-none border-none w-full"/>*/}
                                {/*    </span>*/}
                                {/*</div>*/}
                                <Button type="submit" loading={loading} disabled={loading} icon="pi pi-refresh" label={translate("resend-code")} className="text-xs p-button-text gap-2"/>
                            </>
                        )}
                    </div>
                    {!otpExpired&&(
                        <Button type="submit" loading={loading} disabled={loading||otpExpired||!otp||otp?.length<4} className="w-full text-white text-xs border-round-xl" label={translate("verify-code")}/>
                    )}
                    <Button type="button" disabled={loading} onClick={()=>{
                        setFormType(undefined);
                        // dispatch(setOtpSent(undefined));

                    }} className="w-full p-button-secondary text-xs border-round-xl flex gap-2 align-items-center justify-content-center">
                        <span className={`pi ${isRtl ? "pi-arrow-right" : "pi-arrow-left"} text-xs`} />
                        <span>{translate("go-back")}</span>
                    </Button>

                    {error && <span className="text-red-500">{translate(error)}</span>}
                </form>
            )
            case "PASSWORD":return (
                <form className="w-full lg:w-6 h-auto p-4 sm:p-5 lg:p-6 flex flex-column gap-4 align-items-center justify-content-center fadeinup animation-duration-500" onSubmit={(event) => {
                    event.preventDefault();
                    if (password) runWithValidMobile((identifier) => confirmPassword(identifier, password));
                }}>
                    <div className="text-center w-full flex flex-column gap-2">
                        <span className="font-bold text-3xl text-primary">{translate("enter-password")}</span>
                        <span className="text-xs text-400">{translate("enter-password-description")}</span>
                    </div>
                    <Password toggleMask={true} placeholder={translate("password-input-placeholder")} panelClassName="w-full" inputClassName="w-full border-round-xl ltr" className="w-full" feedback={false} disabled={loading} value={password} autoFocus onChange={(e)=>{setPassword(e.target.value);}} />
                    <div className="flex flex-column gap-2 w-full">
                        <Button type="submit" loading={loading} disabled={loading || !password} className="w-full text-white text-xs border-round-xl" label={translate("login-by-password")}/>
                        <Button type="button" disabled={loading} icon="pi pi-mobile" className="p-button-text w-full text-xs shadow-none border-none gap-2" label={translate("login-by-otp")} onClick={()=>{runWithValidMobile(sendOtp)}}/>
                        <Button type="button" disabled={loading} onClick={()=>{setFormType(undefined);}} className="w-full p-button-secondary text-xs border-round-xl flex gap-2 align-items-center justify-content-center">
                            <span className={`pi ${isRtl ? "pi-arrow-right" : "pi-arrow-left"} text-xs`} />
                            <span>{translate("go-back")}</span>
                        </Button>
                    </div>
                    {error && <span className="text-red-500">{translate(error)}</span>}
                </form>

            )

            default:return(
                <form className="w-full lg:w-6 h-auto flex flex-column p-4 sm:p-5 lg:p-6 justify-content-between fadeinup animation-duration-500" onSubmit={(event) => {
                    event.preventDefault();
                    runWithValidMobile(checkUser);
                }}>
                    <div className="flex-1 flex flex-column align-items-center justify-content-center gap-4">
                        <div className="w-full flex justify-content-center align-items-center lg:hidden">
                            <span className="inline-flex w-16 h-16 sm:w-20 sm:h-20 overflow-hidden flex-shrink-0 align-items-center justify-content-center">
                                <BrandLogo variant="mark" className="block w-full h-full object-contain"/>
                            </span>
                        </div>
                        <div className="text-center w-full flex flex-column gap-2">
                            <h1 className="m-0 text-3xl text-900">{translate("auth-welcome-title")}</h1>
                            <p className="m-0 text-xs text-500 line-height-3">{translate("auth-welcome-description")}</p>
                        </div>
                        <div className="flex w-full align-items-center gap-2">
                            <Divider className="flex-1"/>
                            <span className="text-xs text-500">{translate("signin-signup")}</span>
                            <Divider className="flex-1"/>
                        </div>
                        <div className="w-full">
                            <InputText dir={isRtl ? "rtl" : "ltr"} inputMode="tel" autoComplete="tel" className={`w-full border-round-xl ${isRtl ? "text-right" : "text-left"}`} placeholder={translate("mobile")} value={mobile} onChange={(e)=>{setMobile(e.target.value)}}/>
                            <div className="text-xs text-500 text-center p-1">
                                <span>{translate("auth-consent-prefix")} </span>
                                <span role="button" tabIndex={0} className="font-bold text-primary cursor-pointer" onClick={() => openLegalDialog("terms")} onKeyDown={(event) => legalKeyHandler(event, "terms")}>{translate("auth-legal-terms")} </span>
                                <span>{translate("auth-consent-middle")} </span>
                                <span role="button" tabIndex={0} className="font-bold text-primary cursor-pointer" onClick={() => openLegalDialog("privacy")} onKeyDown={(event) => legalKeyHandler(event, "privacy")}>{translate("auth-legal-privacy")} </span>
                                <span>{translate("auth-consent-suffix")}</span>
                            </div>
                        </div>

                        <Button type="submit" loading={loading} disabled={loading} className="w-full text-xs border-round-xl" label={translate("continue")}/>
                    </div>
                    <div className="flex align-items-center justify-content-between text-xs pt-8">
                        <span role="button" tabIndex={0} className="text-primary font-bold cursor-pointer" onClick={() => openLegalDialog("guide")} onKeyDown={(event) => legalKeyHandler(event, "guide")}>{translate("user-guid")}</span>
                        <span className="text-400">v {packageJson.version}</span>
                    </div>

                    <LegalContentDialog
                        visible={Boolean(legalDialog)}
                        documentName={legalDialog}
                        titleKey={legalDialog === "privacy" ? "auth-legal-privacy" : legalDialog === "guide" ? "user-guid" : "auth-legal-terms"}
                        onHide={() => setLegalDialog(null)}
                    />

                </form>
            )
        }
    }


    return(
        <div className="min-h-screen w-full p-3 sm:p-4 lg:p-6 flex align-items-center justify-content-center overflow-auto">
            <div className={`${config?.dir || "rtl"} w-full md:w-10 lg:w-9 xl:w-8 flex ${isRtl ? "lg:flex-row-reverse" : "lg:flex-row"} lg:surface-card lg:border-round-3xl lg:shadow-2 lg:overflow-hidden`}>
                {render(formType)}
                <section className={`hidden lg:flex flex-1 lg:h-auto align-items-center justify-content-center surface-50 ${isRtl ? "lg:border-right-1" : "lg:border-left-1"} border-200 p-6 xl:p-7`}>
                    <div className="w-full max-w-30rem flex flex-column align-items-center justify-content-center gap-3 xl:gap-4 text-center">
                        <BrandLogo className="block w-full max-w-[16rem] xl:max-w-[18rem] h-auto object-contain"/>
                        <div className="flex flex-column gap-2">
                            <h2 className="m-0 text-base xl:text-lg font-normal text-500 line-height-3">{translate("auth-brand-tagline")}</h2>
                        </div>
                        <div className="w-full">
                            <LoginTextRotator/>
                        </div>
                        <Divider className="w-full my-0"/>
                        <p className="m-0 text-xs xl:text-xs text-600 line-height-3">{translate("auth-brand-description")}</p>
                    </div>
                </section>
            </div>
        </div>
    )
}


export default Index;
